import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Primary-1.svg")